import { useEffect, useState } from 'react';
import '../Header/header.style.css';

function HeaderHome() {
    const [showdisplay, setShowDisplay] = useState('none');
    const [showNavDisplay, setShowNavDisplay] = useState('flex');

    const toggleNav = () => {
        const containerUl = document.getElementById('NavBar-Mobile');
        containerUl.setAttribute('class', 'NavBar-Mobile');
        containerUl.style.display = 'flex';
    }

    const toggleNavClose = () => {
        const containerUl = document.getElementById('NavBar-Mobile');
        containerUl.removeAttribute('class', 'NavBar-Mobile');
        containerUl.style.display = 'none';
    }

    const changeWindow = () => {
        if (window.innerWidth <= 930) {
            setShowDisplay('flex');
            setShowNavDisplay('none');
            return
        }

        if (window.innerWidth >= 931) {
            setShowDisplay('none');
            setShowNavDisplay('flex');
            return
        }
    }

    useEffect(() => {

        if (window.innerWidth <= 930) {
            setShowDisplay('flex');
        }

        if (window.innerWidth >= 931) {
            setShowNavDisplay('flex');
        } else {
            setShowNavDisplay('none');
        }

        const handlerScroll = () => {
            const headerContainer = document.getElementById('Header-Container-Desktop');
            if (window.scrollY > 0) {
                headerContainer.style.position = 'fixed';
                headerContainer.setAttribute('class', ' Position-Fixed');
            } else {
                headerContainer.style.position = 'absulute';
                headerContainer.removeAttribute('class', ' Position-Fixed');
            }
        }

        window.addEventListener('scroll', handlerScroll);

        window.addEventListener('resize', changeWindow);

        return () => {
            window.removeEventListener('scroll', handlerScroll);
            window.removeEventListener('resize', changeWindow);
        }

    }, [])

    return (
        <header id='Header-Container-Desktop'>
            <nav>
                <a className='BranName'>
                    B & M
                </a>
                <ul style={{ display: `${showNavDisplay}` }} id='Menu-Header'>
                    <li>
                        <a href='/'>
                            Inicio
                        </a>
                    </li>
                    <li>
                        <a href='/about'>
                            Sobre Nosotros
                        </a>
                    </li>
                    {/* <li>
                        <a href='/bartender/login'>
                        Soy Bartender
                        </a>
                    </li> */}
                    {/* <span> Servicios
                        <ul>
                            <li>Bartender</li>
                            <li>Meseros</li>
                            <li>Chef</li>
                        </ul>
                    </span> */}
                    <li>
                        <a>
                            Calcular Presupuesto
                        </a>
                    </li>
                    <li>
                        <button>Contactame</button>
                    </li>
                </ul>
                <ul id='NavBar-Mobile' style={{ display: 'none' }}>
                    <div className='Container-Brand-Mobile'>
                        <a>
                            B & M
                        </a>
                        <button className='NavBar-Mobile-Close' onClick={toggleNavClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                            </svg>
                        </button>
                    </div>
                    <div className='NavBar-Mobile-Second'>
                        <li>
                            <a href='/'>
                                Inicio
                            </a>
                        </li>
                        <li>
                            <a href='/about'>
                                Sobre Nosotros
                            </a>
                        </li>
                        <li>
                            <a>
                                Calcular Presupuesto
                            </a>
                        </li>
                        <li>
                            <button>Contactame</button>
                        </li>
                    </div>
                </ul>
                <button onClick={toggleNav} style={{ display: `${showdisplay}` }} className='Icon-Hamburguer-Btn'>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </nav>
        </header>
    )
}

export default HeaderHome;